import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../models/user';
import { AuthService } from '../../providers/auth.service';
import { SessionService } from '../../providers/session.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { faDotCircle, faLock }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
styleUrls:  ['./modal-login.component.css']
})
export class ModalLoginComponent  extends SmsAbstractAppPage implements OnInit {

	@Input() message: string;
	@Input() username: string;
	@Output() logged_in$: EventEmitter<boolean> = new EventEmitter<boolean>();

  user_selected$: EventEmitter<User> = new EventEmitter<User>();

	model: any = { username: '', password: '' };
  	faDotCircle = faDotCircle;
  	faLock = faLock;

  constructor(public activeModal: NgbActiveModal, private authService: AuthService, private sessionService: SessionService) {
  	super();
   }

  ngOnInit() {
  }

    login(){
      this.authService.login(this.model.username, this.model.password)
            .then(result => {
                if (result == true) {
                    // login successful
                    this.logged_in$.emit(result);
                    this.sessionService.user$.subscribe(user => {
                      this.user_selected$.next(user);
                    });
                } else {
                    // login failed
                    this.handleError('Username or password is incorrect');
                }
            }).catch(error => {
              this.handleError(error);
            });
  }


}
